<template>
    <div>
        <v-row class="mt-3 ml-3 mr-5">
            <v-col cols="6">
                <v-btn
                    size="small"
                    color="primary"
                    prepend-icon="mdi-arrow-left-bold"
                    @click="$router.push('/AdminPanel')"
                    >
                    Powrót do panelu
                </v-btn>
            </v-col>
            <v-col cols="6">
                <v-row class="mt-8 justify-end">
                    <v-btn
                        size="small"
                        color="secondary"
                        append-icon="mdi-archive"
                        @click="$router.push('/AdminArchiveOrders')"
                        >
                        Przejdź do zamówień zarchiwizowanych
                    </v-btn>
                </v-row>
            </v-col>
        </v-row>
        <v-row class="ma-16">
          <v-col cols="12">
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels
                    multiple    
                    >
                        <v-expansion-panel 
                        elevation="0"
                        v-for="(item, i) in Orders"
                        :key="i"
                        variant="outlined"
                        class="pa-3 ma-2"
                        >
                            <v-expansion-panel-title class="text-h6 justify-start">
                                <v-col cols="6"> {{ item.ordernum }}  </v-col>
                                <v-col cols="5">  </v-col>
                                <v-col cols="1"> <v-icon :color="item.finished ? 'success' : 'gray'" :icon="item.finished ? 'mdi-check-circle' : 'mdi-progress-clock'"> </v-icon>  </v-col>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-row>
                                    <v-col cols="12">
                                        <span class="text-body-1">Zamówione produkty: </span><span class="text-subtitle-2"> {{ item.products }} <span class="font-weight-black">({{ item.price }}zł)</span></span>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <span class="text-body-2">Metoda płatności: {{ item.payment }} </span> <br />
                                        <span class="text-body-2">Wykorzystano kod rabatowy: {{ item.coupon }} </span>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="4">
                                        <span class="text-body-1">Dane kupującego: </span><br />
                                        <span class="text-caption">{{ item.buyername }}</span> <br />
                                        <span class="text-caption">{{ item.contact }}</span> <br />
                                        <span class="text-caption">{{ item.address }}</span> <br />
                                        <span class="text-caption">{{ item.city }} {{ item.zip_code }} ({{ item.voivodeship }})</span><br />
                                        <span class="text-caption">{{ item.delivery }}</span>
                                    </v-col>
                                    <v-col cols="4">
                                        <span class="text-body-1">Dane do faktury: </span><br />
                                        <div v-if="item.fv_samedata === true"><span class="text-caption">Takie same jak do wysyłki</span></div>
                                        <div v-if="item.fv_samedata !== true">
                                            <span class="text-caption">{{ item.fv_firm }}</span> <br />
                                            <span class="text-caption">{{ item.fv_buyername }}</span> <br />
                                            <span class="text-caption">{{ item.fv_address }}</span> <br />
                                            <span class="text-caption">{{ item.fv_city }} {{ item.fv_zip }} ({{ item.fv_voivodeship }})</span><br />
                                        </div>
                                    </v-col>
                                    <v-col cols="4" class="text-end">
                                        Opłacono: <v-icon :color="item.payed ? 'success' : 'error'" :icon="item.payed ? 'mdi-check-circle' : 'mdi-close-circle'"> </v-icon> <br />
                                        Przesyłka skompletowana: <v-icon :color="item.completed ? 'success' : 'error'" :icon="item.completed ? 'mdi-check-circle' : 'mdi-close-circle'"> </v-icon> <br />
                                        Wysłano: <v-icon :color="item.send ? 'success' : 'error'" :icon="item.send ? 'mdi-check-circle' : 'mdi-close-circle'"> </v-icon> <br />
                                        Zakończono: <v-icon :color="item.finished ? 'success' : 'error'" :icon="item.finished ? 'mdi-check-circle' : 'mdi-close-circle'"> </v-icon> <br />
                                        <v-text-field v-if="item.payed === true && item.completed === true && item.send !== true && item.finished !== true"
                                        v-model="transport_num"
                                        label="Nr wysyłki"
                                        density="compact"
                                        variant="outlined"
                                        ></v-text-field>
                                        <span v-if="item.payed === true && item.completed === true && item.send === true" class="mt-2 text-body-1">nr przesyłki: {{ item.delinum }}</span>
                                    </v-col>
                                </v-row>
                                <v-row class="text-center">
                                    <v-col cols="12" v-if="item.payed !== true && item.completed !== true && item.send !== true && item.finished !== true">
                                        <v-btn size="small" color="primary" @click="confirmPayed(item.ordernum, item.contact)"> Potwierdź opłacenie </v-btn>
                                    </v-col>
                                    <v-col cols="12" v-if="item.payed === true && item.completed !== true && item.send !== true && item.finished !== true">
                                        <v-btn size="small" color="primary" @click="confirmCompleted(item.ordernum, item.contact)"> Zamówienie skompletowane </v-btn>
                                    </v-col>
                                    <v-col cols="12" v-if="item.payed === true && item.completed === true && item.send !== true && item.finished !== true">
                                        <v-btn size="small" :disabled="butdis" color="primary" @click="confirmSend(item.ordernum, item.contact)"> Potwierdź wysłanie </v-btn>
                                    </v-col>
                                    <v-col cols="12" v-if="item.payed === true && item.completed === true && item.send === true && item.finished !== true">
                                        <v-btn size="small" color="primary" @click="confirmFinished(item.ordernum, item.contact)"> Zamknij zamówienie </v-btn>
                                    </v-col>
                                    <v-col cols="12" v-if="item.payed === true && item.completed === true && item.send === true && item.finished === true">
                                        <v-btn size="small" append-icon="mdi-archive" color="secondary" @click="archiveOrder(item.ordernum)"> Archiwizuj </v-btn>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
          </v-col>
        </v-row>
    </div>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from "vuex";

  export default {
    data () {
      return {
        coupname: '',
        discount: '',
        msgSnackbar: false,
        Orders: [],
        transport_num: '',
      }
    },
    created() {
      if(this.isLoggedIn !== true){
        this.$router.push('/AdminLogin')
      }
    },
    methods: {
        getOrders() {
            this.Orders = [],

            axios
            .get(`${process.env.VUE_APP_API}/get_orders`, {params: {'admin_token': `${process.env.VUE_APP_ADMIN_TOKEN}`}})
            .then((resp) => {
            this.Orders = resp.data;
            });
        },

        confirmPayed(ON, contact) {
            var mail = contact.split(' / ')
            mail = mail[1].split(' ')
            mail = mail[0]

            axios
            .put(`${process.env.VUE_APP_API}/order_payed`, {'ordernum': ON, 'admin_token': `${process.env.VUE_APP_ADMIN_TOKEN}`}, {
                headers: { 'Content-Type': 'application/json' }
            });

            axios
            .post(`${process.env.VUE_APP_API}/mail-client`, {
            'to': mail, 
            'subject': '[Alpakowy Raj - Kołdry] Płatność zaksięgowana!', 
            'text': '<h4>Drogi kliencie,<br />serdecznie dziękujemy za dokonanie płatności! <br /></h4>Twoje zamówienie jest teraz kompletowane.<br /> <br />Pozdrawiamy! <br />Zespół Alpakowy Raj - Kołdry <br /><br /><i>--- Wiadomość generowana automatycznie, prosimy na nią nie odpowiadać ---</i>', 
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            setTimeout( () => this.getOrders(), 1500);
            this.$forceUpdate();
            
        },

        confirmCompleted(ON, contact) {
            var mail = contact.split(' / ')
            mail = mail[1].split(' ')
            mail = mail[0]
            axios
            .put(`${process.env.VUE_APP_API}/order_completed`, {'ordernum': ON, 'admin_token': `${process.env.VUE_APP_ADMIN_TOKEN}`}, {
                headers: { 'Content-Type': 'application/json' }
            });
            
            axios
            .post(`${process.env.VUE_APP_API}/mail-client`, {
            'to': mail, 
            'subject': '[Alpakowy Raj - Kołdry] Zamówienie skompletowane!', 
            'text': '<h4>Drogi kliencie,<br />uprzejmie informujemy, że zamówienie zostało skompletowane i czeka na nadanie! <br /></h4>Następnym krokiem jest wysyłka.<br /> <br />Pozdrawiamy! <br />Zespół Alpakowy Raj - Kołdry <br /><br /><i>--- Wiadomość generowana automatycznie, prosimy na nią nie odpowiadać ---</i>', 
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            setTimeout( () => this.getOrders(), 1500);
            this.$forceUpdate();
            
        },

        confirmSend(ON, contact) {
            var mail = contact.split(' / ')
            mail = mail[1].split(' ')
            mail = mail[0]
            axios
            .put(`${process.env.VUE_APP_API}/order_send`, {'ordernum': ON, 'delivery_num':this.transport_num, 'admin_token': `${process.env.VUE_APP_ADMIN_TOKEN}`}, {
                headers: { 'Content-Type': 'application/json' }
            });

            axios
            .post(`${process.env.VUE_APP_API}/mail-client`, {
            'to': mail, 
            'subject': '[Alpakowy Raj - Kołdry] Zamówienie wysłane!', 
            'text': '<h4>Drogi kliencie,<br />zamówienie jest już w drodze! <br /></h4>Możesz śledzić jego drogę na stronie kuriera z pomocą poniższego nr przesyłki:<br /> <h4>'+this.transport_num+'</h4> <br /><br />Pozdrawiamy! <br />Zespół Alpakowy Raj - Kołdry <br /><br /><i>--- Wiadomość generowana automatycznie, prosimy na nią nie odpowiadać ---</i>', 
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            this.transport_num = '';
            setTimeout( () => this.getOrders(), 1500);
            this.$forceUpdate();  
        },

        confirmFinished(ON, contact) {
            var mail = contact.split(' / ')
            mail = mail[1].split(' ')
            mail = mail[0]
            axios
            .put(`${process.env.VUE_APP_API}/order_finished`, {'ordernum': ON, 'admin_token': `${process.env.VUE_APP_ADMIN_TOKEN}`}, {
                headers: { 'Content-Type': 'application/json' }
            });

            axios
            .post(`${process.env.VUE_APP_API}/mail-client`, {
            'to': mail, 
            'subject': '[Alpakowy Raj - Kołdry] Realizacja zakończona!', 
            'text': '<h4>Drogi kliencie,<br />ponownie serdecznie dziękujemy za zakupy w naszym sklepie! <br /></h4>Mamy nadzieję, że zakupiony produkt będzie służył latami i wyniesie komfort snu na zupełnie nowy poziom.<br /> <br />Dziękujemy, pozdrawiamy i zapraszamy ponownie! <br />Zespół Alpakowy Raj - Kołdry <br /><br /><i>--- Wiadomość generowana automatycznie, prosimy na nią nie odpowiadać ---</i>', 
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            setTimeout( () => this.getOrders(), 1500);
            this.$forceUpdate();
            
        },

        archiveOrder(ON) {
            axios
            .put(`${process.env.VUE_APP_API}/order_archive`, {'ordernum': ON, 'admin_token': `${process.env.VUE_APP_ADMIN_TOKEN}`}, {
                headers: { 'Content-Type': 'application/json' }
            });
            setTimeout( () => this.getOrders(), 1500);
            this.$forceUpdate();
            
        },
    },
    mounted () {
        this.getOrders();
    },
    computed: {
        ...mapGetters(['isLoggedIn']),

        butdis() {
            return (this.transport_num === '')
        }
    }
}
</script>